export type RouteNavigationMeta = { fallback: string; backLabel: string; topLevel?: boolean };

const detailParents: Array<[RegExp, string, string]> = [
 [/^\/organization-applications\/[^/]+\/review$/,"/organization-applications","返回团队申请"],
 [/^\/organizations\/[^/]+$/,"/organizations","返回团队管理"],
  [/^\/teachers\/[^/]+\/review$/, "/teachers", "返回教师管理列表"],
  [/^\/courses\/[^/]+\/review$/, "/courses", "返回课程审核列表"],
  [/^\/refunds\/[^/]+\/review$/, "/refunds", "返回退款审核列表"],
];

export function isKnownRoutePath(pathname: string) {
  return pathname === "/login"
    || detailParents.some(([pattern]) => pattern.test(pathname))
    || [
      "/organizations", "/organization-applications", "/", "/users", "/admin-members", "/teachers", "/courses",
      "/course-categories", "/classrooms", "/course-groups", "/group-reports", "/orders",
      "/refunds", "/settlements", "/teacher-income", "/assignments", "/questionnaires", "/operations",
      "/support-tickets", "/roles", "/audit-logs", "/health", "/settings",
    ].includes(pathname);
}
export function getRouteNavigationMeta(pathname: string): RouteNavigationMeta {
  const detail = detailParents.find(([pattern]) => pattern.test(pathname));
  if (detail) return { fallback: detail[1], backLabel: detail[2] };
  return { fallback: "/", backLabel: "返回工作台", topLevel: true };
}
